import React from "react";

import { ReactRegisterModal } from "widgets/RegisterForm/components/ReactRegisterModal";

export const FooterLinks = ({ labels, handleSaveToPersonal, showRegister, setShowRegister }) => {

  return (
    <div className="footer-links">
      <p className="footer-question">{labels.footerQuestion}</p>
      <button className="save-to-personal-btn" onClick={handleSaveToPersonal}>{labels.saveToPersonal}</button>
      <a className="forward-link" href={labels.calcAverage} >{labels.bagrutMutamLink}</a>
      <a className="forward-link" href={labels.calcFinalMechina}>{labels.mechinaLink}</a>
      <a className="forward-link" href={labels.calcHatamaSecondDegree}>{labels.hatamaNihulLink}</a>
      <a className="forward-link" href={labels.chancesAcceptance}>{labels.checkAcceptanceChance}</a>
      <a className="forward-link" href={labels.link_more}>{labels.know_more}</a>
      <ReactRegisterModal
        show={showRegister}
        setShow={setShowRegister}  
        labels={labels.RegisterForm.labels}
        lastAction={{
          action: handleSaveToPersonal
        }}
      />
    </div>
  )
}

